import { debounce } from "@mui/material";
import AppCollection from "components/AppCollection";
import Icon from "components/Icon";
import { Column, Row } from "components/Layout";
import PageHeader from "components/PageHeader";
import ProgressBar from "components/ProgressBar";
import _ from "lodash";
import { search, searchTypeahead } from "modules/gamesAPI";
import { useEffect, useMemo, useState, useRef } from "react";
import colors from "styles/colors";
import texts from "styles/texts";

export function SearchPage() {
  const [inputValue, setInputValue] = useState('');
  const [typeaheadResults, setTypeaheadResults] = useState(null);
  const [searchResults, setSearchResults] = useState(null);
  const [loading, setLoading] = useState(false);
  const inputRef = useRef()

  const poularSearches = [
    'Candy Crush Saga',
    'Animal Crossing',
    'Multiplayer',
    'GardenScapes',
    'Roblox',
    'MineCraft',
  ]

  const fetchTypeahead = useMemo(() => {
    return debounce(async (query, callback) => {
      callback(await searchTypeahead(query))
    }, 300)
  }, [])

  useEffect(() => {
    // don't search until 3 characters have been entered
    if (inputValue.length < 3) {
      setTypeaheadResults(null)
      setSearchResults(null)
      return
    }

    fetchTypeahead(inputValue, ({ results }) => {
      setTypeaheadResults(results)
    });
  }, [fetchTypeahead, inputValue])

  function clearAll() {
    setInputValue('')
    setTypeaheadResults(null)
    setSearchResults(null)
  }

  function selectTypeaheadResult(result) {
    searchQuery(result)
    setInputValue(result)
  }

  function submitSearch(e) {
    e.preventDefault()
    inputRef.current.blur()
    searchQuery(inputValue)
  }

  function searchQuery(query) {
    setLoading(true)
    setSearchResults(null)
    setTypeaheadResults(null)
    search(query).then((res) => {
      setSearchResults(res)
      setLoading(false)
    });
  }

  let body

  if (loading) {
    body = <Column align="mc" style={{ height: '100%' }}>
      <div style={{ width: 40, height: 40 }}>
        <ProgressBar />
      </div>
    </Column>
  } else if (searchResults) {
    if (searchResults.exactResults?.length > 0 || searchResults.results?.length > 0) {
      body = <Column padding="0 0 2rem">
        {!_.isEmpty(searchResults.exactResults) && <AppCollection
          apps={searchResults.exactResults}
          showBanner={true}
          cardType="small"
          style={{ marginBottom: '0.666rem' }}
        />}
        {!_.isEmpty(searchResults.results) && <AppCollection
          apps={searchResults.results}
          cardType="small"
        />}
      </Column>
    } else {
      body = <Column sf="mc" style={{ height: '100%' }} gap="1rem">
        <img src="/img/no_search_results.png" alt="No results found" width={100} height={100} />
        <h3>No results found</h3>
      </Column>
    }
  } else if (inputValue && typeaheadResults) {
    body = <Column padding="0.5rem 2.5rem" gap="1rem">
      {typeaheadResults.map((result, i) => (
        <h5 key={i} onClick={() => selectTypeaheadResult(result)}>
          {result}
        </h5>
      ))}
    </Column>
  } else {
    body = <Column padding="md 1.5rem">
      <h4>Popular Searches</h4>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(50%, 1fr))',
        padding: '0.5rem 0',
      }}>
        {poularSearches.map(term => <h5
          key={term}
          style={{ padding: '0.5rem 0', color: colors.textMedium }}
          onClick={() => selectTypeaheadResult(term)}>
          {term}
        </h5>)}
      </div>
    </Column>
  }

  return (
    <>
      <PageHeader title="Search" settingsMenu background="large">
        <Row padding="1rem 1.5rem 0.5rem 1.5rem" gap="0.5rem">
          {searchResults &&
            <Icon
              name="arrow-left"
              bg="circle"
              color="white"
              bgColor={colors.cardsBackground}
              size={44}
              onClick={clearAll}
            />}

          <form
            onSubmit={submitSearch}
            style={{
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              background: colors.cardsBackground,
              padding: '0 1rem',
              height: 44,
              borderRadius: 22,
              gap: '0.5rem',
            }}
          >
            <input
              ref={inputRef}
              type="text"
              autoFocus
              value={inputValue}
              onChange={e => setInputValue(e.target.value)}
              style={{
                flex: 1,
                background: 'none',
                border: 'none',
                outline: 'none',
                color: colors.textWhite,
                font: texts.subtitleMedium
              }}
            />

            {inputValue && !loading && !searchResults && <Icon name="close" size={14} onClick={clearAll} />}
          </form>
        </Row>
      </PageHeader>

      <div style={{ flex: 1 }}>{body}</div>
    </>
  )
}
